import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { batch, useDispatch } from 'react-redux';

import {
  setSelectedRequest,
  setViewLectureModalState,
} from 'features/courseResume';

function ViewButton({ request }) {
  const dispatch = useDispatch();

  const handleViewClick = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(request));
      dispatch(setViewLectureModalState(true));
    });
  }, [dispatch, request]);

  return (
    <Tappable
      onClick={handleViewClick}
      className="primary bold btn-small"
      noHighlight
    >
      View
    </Tappable>
  );
}

export default ViewButton;
